import { logError } from "@faire/web--source/common/logging";
export var logErrorSignIn = function(currentView, error, options) {
    var _ref;
    return logError((_ref = "".concat(currentView, " - ").concat(error)) !== null && _ref !== void 0 ? _ref : "Error in SignInController for view: ".concat(currentView), options);
};
